import { gql } from '@apollo/client';

export const TagFieldsFragment = gql`
  fragment TagFields on Tag {
    id
    type
    formattedName
  }
`;
